import { Avatar, Button, Stack, Tooltip, Typography } from '@mui/material';

interface IOutroToolTip {
  image: string;
  text: string;
  isLaptopViewOrClosedMenu: boolean;
  onClick: Function;
}

export const OutroToolTip = ({
  image,
  text,
  isLaptopViewOrClosedMenu,
  onClick,
}: IOutroToolTip) => {
  return (
    <Tooltip
      title={
        isLaptopViewOrClosedMenu ? (
          <div></div>
        ) : (
          <Stack onClick={() => onClick()}>
            <Typography
              variant='body6'
              sx={{
                whiteSpace: 'nowrap',
              }}
            >
              {text}
            </Typography>
          </Stack>
        )
      }
      placement='left'
      enterDelay={100}
      enterNextDelay={100}
      slotProps={{
        tooltip: {
          sx: {
            m: 0,
            p: '0 16px 0 0',
            bgcolor: 'transparent',
            cursor: 'pointer',
          },
        },

        popper: {
          style: {
            background: '#2860EA',
            height: '41px',
            minWidth: '100px',
            borderRadius: '32px 0 0 32px',
            display: isLaptopViewOrClosedMenu ? 'none' : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
      }}
    >
      <Button
        sx={{
          width: '100%',
          justifyContent: 'flex-start',
          padding: '10px 24px 10px 0',
          borderRadius: 0,
          gap: '12px',

          ':hover , :focus': {
            cursor: 'pointer',
            bgcolor: 'primary.shade_500',
          },
        }}
        onClick={() => onClick()}
        role='link'
      >
        <Avatar alt='' src={image} sx={{ width: '20px', height: '20px' }} />
        {isLaptopViewOrClosedMenu && (
          <Typography
            variant='body6'
            sx={{
              color: '#fff',
            }}
          >
            {text}
          </Typography>
        )}
      </Button>
    </Tooltip>
  );
};
